export default "__VITE_ASSET__BSrswzE3__"